/* eslint-disable prettier/prettier */
import { Routes, Route } from 'react-router-dom';
import EventPage from 'pages/event/EventPage';
import ArtistsPage from 'pages/artists/ArtistsPage';
import ArtistPage from 'pages/artist/ArtistPage';
import { ArtistProvider } from 'context/ArtistContext';
import HomePageRender from 'utils/HomePageRender';
import GoogleAnalytics from 'components/GoogleAnalytics';
import Blog from './pages/blog/index';
import Album from './pages/album/index';
import DynamicClass from './utils/DynamicClass';
import ScrollToTop from './utils/ScrollToTop';
import ContentPage from './pages/contentpage/index';
import BookingPage from './pages/booking/BookingPage';

function App() {
  return (
    <ArtistProvider>
      <DynamicClass />
      <ScrollToTop />
      <GoogleAnalytics />
      <Routes>
        <Route path="/:contentPageUrlParam" element={<ContentPage />} />
        <Route path="/event/:eventPageUrlParam" element={<EventPage />} />
        <Route path="/blog/:blogLink" element={<Blog />} />
        <Route path="/music/:albumLink" element={<Album />} />
        <Route path="/musica/:albumLink" element={<Album />} />
        <Route path="/1/:memberTypeParam" element={<ArtistsPage />} />
        <Route path="/1/:memberTypeParam/:memberPageUrlParam" element={<ArtistPage />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/" element={<HomePageRender />} />
      </Routes>
    </ArtistProvider>
  );
}

export default App;
